import {
  IonImg,
} from "@ionic/react";
import { Script } from "vm";
import loadingImage from '../../assets/images/loading.png';
import successImage from '../../assets/images/success.png';
interface Props {
  setloaderModal: Function;
}
const LoaderModalComponent: React.FC<Props> = ({ setloaderModal }) => {
  return (
    <>
      <div className="loader-modal" onClick={() => setloaderModal(false)}>
        <div className="loader-modal-wrapper">
          <p className='loading-icon hide'>Calibrating...</p>
          <IonImg src={loadingImage} alt="loader-icon" className='loading-icon hide' placeholder={undefined}></IonImg>
          <p className='success-icon show'>Calibration Complete!</p>
          <IonImg src={successImage} alt="loader-icon" className='success-icon show' placeholder={undefined}></IonImg>
        </div>
      </div>
    </>
  );
};
export default LoaderModalComponent;

